export const origin = "https://lucidmodules.com/";
export const logoUrl = `${origin}lucid-modules.png`;
